import React, { useCallback, useEffect, useState } from "react";
import InputText from "../../../../components/inputs/InputText";
import baseUrl from "../../../../api/baseUrl";
import InputDropSearch from "../../../../components/inputs/InputDropSearch";
import InputSelect from "../../../../components/inputs/InputSelect";
import { scales } from "../../../../data/scale/scale";
import {
  setloadeActive,
  setloadeDeactive,
} from "../../../../redux/loader/loaderActions";
interface FormData {
  brandId: string;
  scale: string;
  categoryId: string;
  productName: string;
  alertQuantity: number;
  quantity: number;
  price: number;
  wholePrice: number;
}
interface AddProductProps {
  closeModal: () => void;
  title?: string;
  id?: string;
  priceOnly: boolean;
}

const AddProduct: React.FC<AddProductProps> = ({
  closeModal,
  id,
  priceOnly,
}) => {
  const [formData, setFormData] = useState<FormData>({
    brandId: "",
    categoryId: "",
    productName: "",
    alertQuantity: 0,
    price: 0,
    quantity: 1,
    wholePrice: 0,
    scale: "",
  });
  const [errors, setErrors] = useState(false);
  const handleChange = useCallback(
    (e: any) => {
      const { name, value } = e.target;

      setFormData((prevData) => {
        if (name === 'quantity' || name === 'wholePrice') {
          const newValue = Number(value);
          
          // Avoid division by zero
          const newPrice =
            name === 'quantity'
              ? newValue === 0
                ? 0
                : prevData.wholePrice / newValue
              : newValue === 0
                ? 0
                : newValue / prevData.quantity;
  
          return {
            ...prevData,
            [name]: newValue,
            price: newPrice,
          };
        }
  
        return { ...prevData, [name]: value };
      });
    },
    [] 
  );

  const [brand, setbrand] = useState([]);
  const [category, setcategory] = useState([]);

  const getBrandData = useCallback((search: any) => {
    baseUrl
      .get("client/inventory/product/searchAllBrand", {
        headers: {
          keyword: search,
        },
      })
      .then((response) => {
        setbrand(response.data.data);
      })
      .catch((error) => {
        console.error(error?.response);
      });
  }, []);

  const getCategoryData = useCallback((search: any) => {
    baseUrl
      .get("client/inventory/product/searchAllCategory", {
        headers: {
          keyword: search,
        },
      })
      .then((response) => {
        setcategory(response.data.data);
      })
      .catch((error) => {
        console.error(error?.response);
      });
  }, []);

  useEffect(() => {
    getBrandData("");
    getCategoryData("");

  }, []);
  const getProductData = useCallback((id: any) => {
    baseUrl
      .get("client/inventory/product/findProductById", {
        headers: {
          productid: id,
        },
      })
      .then((response) => {
        setFormData((prev) => ({
          ...prev,
          brandId: response.data.data.brandId,
          categoryId: response.data.data.categoryId,
          productName: response.data.data.productName,
          alertQuantity: response.data.data.alertQuantity,
          price: response.data.data.price,
          wholePrice: response.data.data.price,
          scale: response.data.data.scale,
        }));
      })
      .catch((error) => {
        console.error(error?.response);
      });
  }, []);
  useEffect(() => {
    if (id) {
      getProductData(id);
    }

  }, [id]);

  const searchBrand = (e: any) => {
    getBrandData(e);
  };

  const searchCategory = (e: any) => {
    getBrandData(e);
  };
  const handleSubmit = useCallback(
    (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault();
      setloadeActive();
      const {
        brandId,
        categoryId,
        productName,
        alertQuantity,
        quantity,
        wholePrice,
        scale,
        price,
      } = formData;

      if (
        !brandId ||
        !categoryId ||
        !productName ||
        alertQuantity <= 0 ||
        quantity <= 0 ||
        wholePrice <= 0 ||
        !scale ||
        price <= 0
      ) {
        setErrors(true);
        setloadeDeactive();
        return;
      }

      const request = id
        ? baseUrl.patch(
            "client/inventory/product/updateProductPriceById",
            formData,
            { headers: { productid: id } }
          )
        : baseUrl.post("client/inventory/product/createProduct", formData);

      request
        .then(() => {
          setloadeDeactive();
          closeModal();
        })
        .catch((error) => {
          console.error(error?.response);
          setloadeDeactive();
        });
    },
    [formData, closeModal, id]
  );

  const modelClose = useCallback(() => {
    closeModal();
    setFormData((prev) => ({
      ...prev,
      brandId: "",
      categoryId: "",
      productName: "",
      alertQuantity: 0,
      price: 0,
    }));
  }, [closeModal, formData]);
  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-white dark:bg-slate-800 rounded-[8px] shadow-2xl w-full max-w-lg max-h-[90vh] overflow-hidden flex flex-col">
        {/* Header */}
        <div className="px-3 py-2 border-b border-slate-200 dark:border-slate-600 flex items-center justify-between">
          <h2 className="text-xs font-bold text-slate-800 dark:text-slate-100">
            {id ? "Update Product" : "Add Product"}
          </h2>
          <button
            onClick={modelClose}
            className="w-6 h-6 rounded-md bg-slate-100 dark:bg-slate-700 hover:bg-slate-200 dark:hover:bg-slate-600 flex items-center justify-center text-slate-600 dark:text-slate-300 transition-colors"
          >
            ✕
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="flex-1 overflow-y-auto p-3 space-y-3">
          <InputDropSearch
            data={brand}
            name="brandId"
            label={"Brand Name"}
            selectName1="brandName"
            value={formData.brandId}
            selectValue="_id"
            onChange={handleChange}
            onSearch={searchBrand}
            isDisable={priceOnly}
            errors={errors && formData.brandId === ""}
          />
          <InputDropSearch
            data={category}
            name="categoryId"
            label={"Category"}
            selectName1="categoryName"
            selectValue="_id"
            value={formData.categoryId}
            onChange={handleChange}
            onSearch={searchCategory}
            isDisable={priceOnly}
            errors={errors && formData.categoryId === ""}
          />

          <InputText
            onChange={handleChange}
            value={formData.productName}
            name="productName"
            label={"Product Name"}
            isDisable={priceOnly}
            errors={errors && formData.productName === ""}
          />
          <InputSelect
            option={scales}
            name="scale"
            label={"Units of Measure"}
            value={formData.scale}
            onChange={handleChange}
            isDisable={priceOnly}
            errors={errors && formData.scale === ""}
          />

          <div className="grid grid-cols-2 gap-4">
            <InputText
              onChange={handleChange}
              value={formData.quantity}
              name="quantity"
              type="number"
              label={`Units (${formData.scale || "unit"})`}
              errormessage={"Units must be greater than zero."}
              errors={errors && formData.quantity <= 0}
            />
            <InputText
              onChange={handleChange}
              value={formData.wholePrice}
              name="wholePrice"
              type="number"
              label={"Price"}
              errormessage={"Price must be greater than zero."}
              errors={errors && formData.wholePrice <= 0}
            />
          </div>

          <div className="p-2.5 bg-indigo-50 dark:bg-indigo-900/40 rounded-lg">
            <p className="text-xs text-slate-600 dark:text-slate-300">
              Price per 1 {formData.scale || "unit"}:{" "}
              <span className="font-bold text-indigo-600 dark:text-indigo-300">
                {formData.price.toFixed(2)}
              </span>
            </p>
          </div>

          <InputText
            onChange={handleChange}
            value={formData.alertQuantity}
            name="alertQuantity"
            label={`Alert Quantity (${formData.scale || "unit"})`}
            isDisable={priceOnly}
            type="number"
            errormessage={"Quantity must be greater than zero."}
            errors={errors && formData.alertQuantity <= 0}
          />

          {/* Footer */}
          <div className="flex gap-2 pt-2 border-t border-slate-200 dark:border-slate-600">
            <button
              type="button"
              onClick={modelClose}
              className="flex-1 px-4 py-2.5 rounded-lg border border-slate-200 dark:border-slate-600 text-slate-600 dark:text-slate-300 font-medium hover:bg-slate-50 dark:hover:bg-slate-700 transition-colors text-xs"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="flex-1 px-4 py-2.5 rounded-lg bg-gradient-to-r from-primary to-primaryLight text-white font-medium hover:shadow-lg hover:shadow-primary/20 transition-all text-xs"
            >
              {id ? "Update" : "Submit"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default React.memo(AddProduct);
